<div *ngIf="isVisible">
  <sk-graph-journey-explorer
    [displayName]="displayName"
    [journey]="journey"
    [orderId]="orderId"
    [params]="params"
  ></sk-graph-journey-explorer>
</div>
<sk-no-data *ngIf="!isVisible" header="Not Authorized" subheader="You are not authorized to use this tool"></sk-no-data>
